"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeetTheTeam() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const teamMembers = [{
    id: 1,
    name: "Jane Doe",
    position: "BCBA",
    bio: "Board Certified Behavior Analyst with over 10 years of experience in autism therapy and family training.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/jane_doe_bcba_portrait.png"
  }, {
    id: 2,
    name: "Luis Rodriguez",
    position: "Therapist",
    bio: "Licensed therapist specializing in in-home ABA services and bilingual support.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/luis_rodriguez_therapist_portrait.png"
  }, {
    id: 3,
    name: "Sarah Chen",
    position: "Clinical Supervisor",
    bio: "Experienced supervisor dedicated to quality care and professional development.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1541246/img/sarah_chen_supervisor_portrait.png"
  }];
  return <section id="meet-the-team" className="py-16 lg:py-24 bg-dark-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-foreground-dark mb-4">Meet the Team</h2>
          <p className="text-foreground-dark/80 max-w-2xl mx-auto text-lg">
            Our compassionate professionals are dedicated to providing evidence-based care for children and families.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {teamMembers.map((member, i) => {
          const itemRef = i === 0 ? ref1 : i === 1 ? ref2 : null;
          const itemVisible = i === 0 ? isVisible1 : i === 1 ? isVisible2 : true;
          return <div key={member.id} data-index={i} ref={itemRef || undefined} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${itemVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="group bg-white border-none shadow-soft hover:shadow-strong hover:-translate-y-2 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] overflow-hidden">
                  <div className="overflow-hidden rounded-t-xl">
                    <img src={member.image} alt={member.name} className="w-full h-72 object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:scale-[1.02]" />
                  </div>
                  
                  <CardContent className="pt-6">
                    <h3 className="text-foreground mb-1">{member.name}</h3>
                    <p className="text-primary font-semibold mb-4">{member.position}</p>
                    <p className="text-muted-foreground text-sm leading-relaxed mb-4">
                      {member.bio}
                    </p>
                    <Link to="#" className="text-primary hover:text-primary-hover font-semibold text-sm inline-flex items-center transition-all duration-[var(--duration-fast)] group-hover:opacity-100 opacity-80">
                      Read More
                      <span className="ml-1 transition-transform duration-[var(--duration-fast)] group-hover:translate-x-1">→</span>
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}